import { ListItemText } from "@mui/material";
import { Package } from "react-feather";
import { useTranslation } from "react-i18next";

import EditableItemListItem from "../../../../../components/editableItemList/EditableItemListItem";
import { IDeliveryItem } from "../../../../../models/deliveryItem";

interface DeliveryItemListItemProps {
  deliveryItem: IDeliveryItem;
  onEdit: (item: IDeliveryItem) => void;
  onDelete: (id: string) => void;
}

const DeliveryItemListItem = (props: DeliveryItemListItemProps) => {
  const { t } = useTranslation();
  const { deliveryItem, onEdit, onDelete } = props;

  return (
    <EditableItemListItem
      item={deliveryItem}
      itemId={deliveryItem.id}
      onEdit={onEdit}
      onDelete={onDelete}
      icon={<Package className="list-item-icon" size={24} />}
    >
      <ListItemText
        sx={{ wordBreak: "break-all" }}
        primary={`${deliveryItem.position} - ${deliveryItem.material} - ${deliveryItem.stockType} `}
        secondary={`${t("quantity")}: ${deliveryItem.quantity} ${deliveryItem.unitOfMeasurement}`}
      />
    </EditableItemListItem>
  );
};

export default DeliveryItemListItem;
